module.exports = __webpack_public_path__ + "img/roadmap-phase-1-cell-6-icon.612bfcb7.png";